import { inject, Injectable } from '@angular/core';
import { createPaymentTracker } from 'src/app/core/services/tracking/utils/payment-tracker.util';
import { IPaymentDetails } from '../../../../interfaces/payment.interface';
import { TrackingService } from '../../../../services/tracking/tracking.service';
import { Payment } from '../../domain/model/payment.model';
import { PaymentContext } from '../../domain/value-objects/payment-context.model';

@Injectable({ providedIn: 'root' })
export class PaymentTrackerService {
  private readonly tracking = inject(TrackingService);
  private readonly tracker = createPaymentTracker(this.tracking);

  trackPaymentInitiation(
    context: PaymentContext,
    details: IPaymentDetails
  ): void {
    const { paymentSummary, entriesToPay, isAccountClosed, isTicketGenerated } =
      details;

    this.tracker(
      `Manual payment initiated. Method: ${paymentSummary.paymentMethod}, type: ${paymentSummary.paymentType}`
    );
    this.tracker(`Account to pay: ${context.account?.id}`);
    this.tracker(`Ticket required: ${isTicketGenerated}`);
    this.tracker(`Closed account: ${isAccountClosed}`);
    this.tracker(`Total amount: ${paymentSummary.totalAmount}`);
    this.tracker('Entries to pay:', {
      customData: {
        entries: entriesToPay,
      },
    });
  }

  trackPaymentCompletion(
    payment: Payment,
    paymentDetails: IPaymentDetails
  ): void {
    this.tracker('Manual payment completed', { paymentId: payment._id });

    if (paymentDetails.isAccountClosed) {
      this.tracker(`Account closed at ${new Date().toISOString()}`, {
        accountId: payment.negocio_id,
      });
    }
  }

  trackTicketGenerated(serie: string, ticketId: string): void {
    this.tracker(`Ticket generated. Serie: ${serie}. Id: ${ticketId}`);
  }

  trackTicketEventUpdate(ticketEventId?: string): void {
    this.tracker('Updating ticket event', {
      customData: {
        ticketEventId,
      },
    });
  }
}
